import { Divider, Flex, Heading } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';

import { useStores } from '../hooks/useStores';
import BackupTracks from './BackupTracks';
import PlaybackQueue from './PlaybackQueue';
import UserGuests from './UserGuests';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        sidebarWidth: store.config.sidebarWidth,
        footerHeight: store.config.footerHeight,
        headerHeight: store.config.headerHeight,
    }));
}

const Sidebar = () => {
    const { sidebarWidth, footerHeight, headerHeight } = useStoreData();

    return (
        <Flex
            maxW={['100%', '100%', '400px', `${sidebarWidth}px`]}
            w="100%"
            overflow="hidden"
            borderRadius="0 30px 30px 0"
            flexDirection="column"
            maxH="100vh"
            transform="rotate3d(0,0,0,0deg)"
            display={['none', 'none', 'flex']}
            className="background-transparent"
        >
            <Flex display={['none', 'none', 'flex']} alignItems="center" p=".5rem 1rem" minH={headerHeight}>
                <Heading fontSize="30px">oneplaylist.io</Heading>
            </Flex>
            <Flex flex={1} overflow="auto" mr="-15px">
                <Flex w="100%" direction="column">
                    <PlaybackQueue />
                    <BackupTracks />
                </Flex>
            </Flex>
            <Flex
                justifyContent="space-between"
                p=".5rem 1rem"
                height={footerHeight}
                direction="column"
                display={['none', 'none', 'flex']}
            >
                <Divider opacity={0.2} mt="0" mb=".5rem" minW={'100%'} />
                <UserGuests />
            </Flex>
        </Flex>
    );
};

export default Sidebar;
